import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      2023 WebSternmedia VideoReView
    </footer>
  );
}

export default Footer;